module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pointer flex flex-column w-45 w-100-mobile br3 pa3 mh3-l h-100",
    class: {
      'container-selected': _vm.selected
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "flex flex-row justify-between items-center plan-title"
  }, [_c('div', {
    staticClass: "flex flex-row items-center flex-grow-1 w-100-mobile"
  }, [(_vm.isAKKOPlan) ? _c('akko-plan-icon', {
    attrs: {
      "alt": "AKKO Plan",
      "height": "60",
      "width": "60"
    }
  }) : _c('device-icon', {
    attrs: {
      "alt": "Phone Plan",
      "height": "60",
      "width": "60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-grow-1 mr1",
    staticStyle: {
      "margin-left": "0.75rem"
    }
  }, [_c('h5', {
    staticClass: "ma0 cera-round-pro",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isAKKOPlan ? 'The AKKO' : 'Phone-Only') + " Plan\n        ")]), _vm._v(" "), _c('h6', {
    staticClass: "ma0 cera-round-pro grey",
    class: {
      'red': _vm.selected
    },
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isAKKOPlan ? 'Protect Phone + 25 items' : 'Protect Your Phone') + "\n        ")])]), _vm._v(" "), (_vm.selected) ? _c('red-tick-icon', {
    staticClass: "mr2"
  }) : _vm._e()], 1)]), _vm._v(" "), _c('plan-info', {
    attrs: {
      "type": _vm.type,
      "includeOpen": _vm.includeOpen,
      "toggleInclude": _vm.toggleInclude
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17ee3254", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ee3254","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/selectBox/PlanToggleCard.vue
// module id = 824
// module chunks = 0